<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{
      caixaAlta(limitar(bloqueio.profissional.nome, 30))
    }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Data Início</strong></td>
            <td>{{ formatarData(bloqueio.dataInicio, 'DD/MM/YYYY') }}</td>
          </tr>
          <tr>
            <td><strong>Data Fim</strong></td>
            <td>{{ formatarData(bloqueio.dataFim, 'DD/MM/YYYY') }}</td>
          </tr>
          <tr>
            <td><strong>Horário</strong></td>
            <td>{{ bloqueio.horarioInicio }} - {{ bloqueio.horarioFim }}</td>
          </tr>
          <tr>
            <td><strong>Motivo</strong></td>
            <td>{{ bloqueio.motivo }}</td>
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td :class="bloqueio.ativo ? 'text-success' : 'text-danger'">{{
              bloqueio.ativo ? 'Ativo' : 'Cancelado'
            }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          data-test-id="link-auto-1"
          :to="'/profissional/bloqueio/cadastro/' + bloqueio._id"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" /> Editar
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'ProfissionalBloqueioFicha',
  props: {
    bloqueio: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
